<template>
  <div class="Main" id="Main">
    <div
      :class="['navBox', style.Fixed ? 'ys-navBarFixed' : 'ys-navBar', style.shadow ? 'ys-shadow' : '']"
      :style="{background: style.bg ? '#fff' : 'transparent'}"
    >
      <navbar :styleObj="style"></navbar>
    </div>
    <div :style="{width: '100%', height: '100%'}">
      <router-view :windowWidth="width" :windowHeight="height" :roll="roll"/>
    </div>
  </div>
</template>

<script>
  import navbar from '@/components/navbar/navbar.vue'
  import {mapMutations} from 'vuex'

  export default {
// BY zgc19 ON 2019/1/17
    name: 'Main',
    data () {
      return {
        width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        // window: this.getWindow() === 'pc' || false, // true为pc端否则就是移动端
        rolls: 1,
        roll: 1,
        routeName: '',
        style: {}
      }
    },
    watch: {
      'rolls' (to) {
        this.roll = to
      },
      '$store.state.app.navStyle' (to) {
        this.style = to
      },
      '$route.name' (to) {
        this.routeName = to
      },
      'routeName' (to) {
      }
    },
    created () {
      this.routeName = this.$route.name
      this.putWidth(this.width)
      this.putHeight(this.height)
      this.style = this.$store.state.app.navStyle
      this.putHtmlFontSize(this.width)
    },
    methods: {
      ...mapMutations([
        'getWindowWidth',
        'getWindowHeight'
      ]),
      putWidth (to) {
        this.getWindowWidth(to)
      }, // 存入宽度
      putHeight (to) {
        this.getWindowHeight(to)
      }, // 存入高度
      scrollFunc (v) {
        if (v < 0) { // 鼠标向下滚动
          this.rolls += 1
        } else { // 鼠标向上滚动
          this.rolls -= 1
        }
      }, // 获取鼠标滚动方向
      putHtmlFontSize (width) {
        let px = width / 10
        if (px <= 75 || px >= 140) {
          document.querySelector('html').style.fontSize = px + 'px'
        } else {
          document.querySelector('html').style.fontSize = '140px'
        }
      } // 修改html字体大小
      // getWindow () {
      //   let browser = {
      //     versions: (function () {
      //       let u = navigator.userAgent
      //       return { // 移动终端浏览器版本信息
      //         mobile: !!u.match(/AppleWebKit.*Mobile.*/) // 是否为移动终端
      //       }
      //     })()
      //   }
      //   if (browser.versions.mobile) { // 判断是否是移动设备打开。browser代码在下面
      //     return 'webapp'
      //   } else { // 否则就是PC浏览器打开
      //     return 'pc'
      //   }
      // } // 判断当前窗口是移动端还是pc端
    },
    mounted () {
      let _this = this
      window.onresize = () => { // 定义窗口大小变更通知事件
        let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth // 窗口宽度
        let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight // 窗口高度
        _this.height = height
        if (width < 1000 && width > 750) {
          _this.putHtmlFontSize(1000)
        } else {
          _this.putHtmlFontSize(width)
        }
        _this.width = width
        _this.putWidth(width)
        _this.putHeight(height)
      }
      let scrollFunc = e => {
        e = e || window.event
        clearTimeout(window.iTime)
        window.iTime = setTimeout(() => {
          this.scrollFunc(e.wheelDelta)
        }, 100)
      }
      if (document.addEventListener) {
        document.addEventListener('DOMMouseScroll', scrollFunc, false)
      } // W3C
      window.onmousewheel = document.onmousewheel = scrollFunc // IE/Opera/Chrome/Safari
    },
    components: {
      navbar
    }
  }
</script>

<style scoped lang="scss">
  @function p2r($size) {
    @return $size/75 * 1rem;
  }

  .Main {
    .ys-navBarFixed {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 90;
    }

    .navBox {
      transition: all .5s;
    }

    .ys-navBar {
      width: 100%;
      z-index: 90;
    }
  }

  @media screen and (min-width: 750px) {
    .Main {
      .ys-shadow {
        box-shadow: 0 7px 22px 0 rgba(0, 0, 0, .08);
      }
    }
  }

  @media screen and (max-width: 750px) {
    .Main {
      .ys-shadow {
        box-shadow: 0 p2r(7) p2r(22) 0 rgba(0, 0, 0, .08);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Main.vue